<script lang="ts">
    import {WalkerService} from 'shared/services';
    import {getInjector, getLocalization} from 'src/core';

    const localize = getLocalization();
    const walker = getInjector().getByClass(WalkerService);

    function redirect() {
        walker.newPage(`/login/cas?redirect=${encodeURIComponent(window.location.href)}`);
    }
</script>

<div class="login-system login-system-cas">
    <button class="btn btn-primary btn-block btn-cas-login"
            data-qa="cas-login-button"
            on:click={redirect}>
        {localize(/* @kp-localization login.prihlaseniJasigem */ 'login.prihlaseniJasigem')}
    </button>
</div>

<style lang="less">
    .btn-cas-login {
        color: #fff;
        background-color: #e61000;
        border-color: #e61000;
    }

    .btn-cas-login:hover,
    .btn-cas-login:focus {
        color: #fff;
        background-color: #c10;
        border-color: #b10;
    }

    .btn-cas-login:active {
        color: #fff;
        background-color: #b10;
        border-color: #800;
    }

</style>